/**
 * UI labels for the MEAL module (internal app id and routes remain `mel`).
 * Monitoring, Evaluation, Accountability and Learning.
 */
export const MEAL_APP_NAME = 'MEAL';
export const MEAL_APP_DESCRIPTION =
  'Monitoring, Evaluation, Accountability & Learning';
export const MEAL_FORMS_LABEL = 'MEAL Forms';
export const MEAL_WORKSPACE_TAGLINE =
  'Monitoring, Evaluation, Accountability & Learning Workspace';
